import { clsModel, fnCreate } from '@cls/clsModel'
import { salesinvoice_payments as api } from '@app/api'
import string from '@lib/string'
import eventbus from '@app/eventbus'

// We operate on a sales invoice, no special model name for sending an invoice. 
var modelName = "salesinvoice_payment";
const fields = ['id', 'id_invoice', 'inv_total', 'inv_number', 'inv_open', 'paym_amount', 'paym_date', 'paym_remark'];


class clsSalesInvoicePayment extends clsModel {

    id_invoice  = null;
    inv_total   = null;
    inv_number  = null;
    inv_open    = null;
    paym_amount = null;
    paym_date   = null;
    paym_remark = null;

    /* 
     * The amount is mandatory only when an open invoice amount exists.
    */
    get amountMandatoryRules() {
        if (!this.paym_amount) {
            return [];
        }
        return this.rules.mandatory;
    }
    /**
     * Loada new payment
     */
    async doCreate(defaults) {
        var result = await api.loadNew(defaults.id)
        defaults = result.data;
        return super.doCreate(defaults);
    }

    /**
     * After save, make sure the invoice model is updated.
     * @param {*} resultData 
     */
    onAfterSave(resultData) {
        var sendData = {...resultData};
        sendData.id = sendData.id_invoice;
        eventbus.model.saved("salesinvoice", sendData);
    }
    
    constructor() {
        super({
          api: api,   
          modelName: modelName, 

          fillable: fields
        })
    } 
        
 }
 export default fnCreate(clsSalesInvoicePayment, 'clsSalesInvoicePayment');
